export const SSID_TEMPLATE_SECTION_EVENT =
	'canvas-agent:ssid-template:section';
export const SSID_TEMPLATE_FILTER_EVENT =
	'canvas-agent:ssid-template:filter';
export const SSID_TEMPLATE_FOCUS_EVENT =
	'canvas-agent:ssid-template:focus';
export const SSID_TEMPLATE_CREATE_MODAL_EVENT =
	'canvas-agent:ssid-template:create-modal';
export const SSID_TEMPLATE_EDIT_MODAL_EVENT =
	'canvas-agent:ssid-template:edit-modal';
export const SSID_TEMPLATE_DELETE_MODAL_EVENT =
	'canvas-agent:ssid-template:delete-modal';
